// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__pG8Js","label":"Completed_label__33y0V"};